import axios from "axios";
import CoreService from "./core.service";

axios.defaults.withCredentials = true;

export const getPackages = () => {
  return axios.get(`${CoreService.getPrivateURL()}packages/`, {withCredentials:true} );
};
export const getMyPackages = () => {
  return axios.get(`${CoreService.getPrivateURL()}my_package/`, {withCredentials:true} );
};
export const getPackage = (Package_id) => {
  return axios.get(`${CoreService.getPrivateURL()}packages/` + Package_id, {withCredentials:true} );
};
export const insertPackage = (values) => {
  return axios.post(`${CoreService.getPrivateURL()}packages/`, values, {withCredentials:true} );
};
export const updatePackage = (Package_id, data ) => {
  return axios.put(`${CoreService.getPrivateURL()}packages/${Package_id}`, data, {withCredentials:true});
};
export const removePackage = (Package_id ) => {
  return axios.delete(`${CoreService.getPrivateURL()}packages/${Package_id}`, {withCredentials:true});
};
export const disablePackage = (Package_id ) => {
  return axios.patch(`${CoreService.getPrivateURL()}packages/${Package_id}`, {withCredentials:true});
};

export const expirePackage = (id) => {
  return axios.put(`${CoreService.getPrivateURL()}packages_expire/${id}`);
};

export const deliverPackage = (id, deliver_to) => {
  return axios.put(`${CoreService.getPrivateURL()}packages_delivery/${id}?deliver_to=${deliver_to}`);
};

const PackagesService = {
  getPackages,
  getMyPackages,
  getPackage,
  insertPackage,
  updatePackage,
  removePackage,
  disablePackage,
  deliverPackage
};
export default PackagesService;
